import { Eye, EyeSlash } from "@phosphor-icons/react";
import { startTransition, Suspense, useId, useState } from "react";

import { loadOptions } from "~/utils/password";

import { FormControl } from "../FormControl";
import { Input } from "../Input";
import PasswordStrength from "./PasswordStrength";

export const PasswordField: React.FC<
  Pick<React.ComponentProps<typeof FormControl>, "error" | "label">
> = ({ label = "Password", ...props }) => {
  const id = useId();
  const [value, setValue] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [hasTyped, setHasTyped] = useState(false);
  const [optionsPromise] = useState(loadOptions());
  return (
    <div className="space-y-4">
      <FormControl id={id} label={label} {...props}>
        <div className="relative grid">
          <Input
            required
            name="password"
            placeholder="Enter a strong password"
            autoComplete="new-password"
            type={isVisible ? "text" : "password"}
            value={value}
            onChange={async (event) => {
              if (!hasTyped) {
                startTransition(() => {
                  setHasTyped(true);
                });
              }
              setValue(event.target.value);
            }}
          />
          <div className="absolute right-2 top-2">
            <div
              className="tooltip tooltip-left"
              data-tip={`${isVisible ? "Hide" : "Show"} password`}
            >
              <button
                type="button"
                className="btn btn-square btn-sm"
                onClick={() => {
                  setIsVisible((prev) => !prev);
                }}
              >
                {isVisible ? (
                  <EyeSlash weight="bold" className="size-5" />
                ) : (
                  <Eye weight="bold" className="size-5" />
                )}
              </button>
            </div>
          </div>
        </div>
      </FormControl>
      <Suspense>
        {hasTyped && (
          <PasswordStrength promise={optionsPromise} value={value} />
        )}
      </Suspense>
    </div>
  );
};
